import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
// import Home from '../pages/Home.vue';
//import ScreenDesign1 from '../pages/ScreenDesign1.vue';
import ScreenDesign2 from '../pages/ScreenDesign2/ScreenDesign2.vue';
//import ScreenDesign3 from '../pages/ScreenDesign3/ScreenDesign3.vue';
//import { component } from 'vue/types/umd';
 import ScreenDesign4 from '../pages/ScreenDesign4/ScreenDesign4.vue';
 import ScreenDesign6 from '../pages/ScreenDesign6/ScreenDesign6.vue';
 import ScreenDesign7 from '../pages/ScreenDesign7/ScreenDesign7.vue';
const routes = [
  { path: '/home', component: ScreenDesign2, name:'ScreenDesign2' },
  { path: '/', redirect: '/home' },   /*默认跳转路由*/
  { path: '/gangwei', component:ScreenDesign4 },
  { path: '/resume', component:ScreenDesign6 },
  { path: '/field', component:ScreenDesign7 },
]

const router = new VueRouter({
  mode: 'hash', 
  routes 
})

export default router;